export default __webpack_public_path__ + "static/media/pic-reset-case.c715ecd1.svg";